import request from '@/utils/request'

// 新增质押融资服务-申报
export function addZyrzfwsb(data) {
  return request({
    url: '/web/zyrzfw',
    method: 'post',
    data: data
  })
}

// 修改质押融资服务-申报
export function updateZyrzfwsb(data) {
  return request({
    url: '/web/zyrzfw/edit',

    method: 'post',
    data: data
  })
}

// 查询质押融资服务-申报详细
export function getZyrzfwsb(recid) {
  return request({
    url: '/web/zyrzfw/' + recid,
    method: 'get'
  })
}